// material-ui
import { useTheme } from '@mui/material/styles';

// project-imports
import { ThemeMode } from 'config';

// assets
import yoraSymbol from 'assets/images/yora/yora-symbol.svg';
import yoraSymbolDark from 'assets/images/yora/yora-symbol-dark.svg';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return <img src={theme.palette.mode === ThemeMode.DARK ? yoraSymbolDark : yoraSymbol} alt="Yora" width="36" />;
}
